import {
  examApi,
  type ExamReportParams,
  type ExamSchedule as ExamScheduleValue,
  type ExamType,
} from '@mathflat/domain/Exam'
import {
  type ExamOfMonthParams,
  type StudentExam,
  studentExamApi,
  type StudentExamAssignPayload,
} from '@mathflat/domain/StudentExam'

import { mpEventInfo } from '@/constant'
import { ExamSchedule } from '@/dto/Exam/ExamSchedule'

export class ExamController {
  async assignStudentExam(
    examId: StudentExamAssignPayload['examId'],
    studentIdList: StudentExamAssignPayload['studentIdList'],
  ) {
    await studentExamApi.assignStudentExams(
      { examId, studentIdList },
      { mp_event_name: mpEventInfo.학력평가_시험지출제 },
    )
  }

  async unAssignStudentExam(studentExamIds: StudentExam['id'][]) {
    await studentExamApi.unassignStudentExams(studentExamIds, {
      mp_event_name: mpEventInfo.학력평가_시험지출제취소,
    })
  }

  async getReport(param: ExamReportParams) {
    return examApi.getExamReportFile(param)
  }

  async getExamSchedule(type: ExamType = 'KMM') {
    const schedules = await examApi.getExamSchedules(type)
    return schedules.map((schedule) => new ExamSchedule(schedule))
  }

  async getExamByYearMonth({ yearMonth, type = 'KMM' }: ExamOfMonthParams) {
    return studentExamApi.getExamsWithStudentExams({ yearMonth, type })
  }

  async getExamAwardByYearMonth({ yearMonth, type = 'KMM' }: ExamOfMonthParams) {
    return studentExamApi.getExamAwards({ yearMonth, type })
  }

  async downloadCertificates({ round }: { round: ExamScheduleValue['round'] }) {
    const { blob, fileName } = await examApi.getExamCertificatesFile({ type: 'KMM', round })
    return { blob, fileName: fileName ?? `KMM_${round}회_상장.zip` }
  }
}

export const examController = new ExamController()
